import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

class StockAdjustment extends Component {
  render() {
    const { translate, cdMenuChild, accessMenus, user } = this.props

    const linkClick = (cdMenuChild, root) => {
      switch (root) {
        case 'stock.adjustment.made.title':
          cdMenuChild = 1102
          break
        case 'stock.adjustment.value.title':
          cdMenuChild = 1101
          break
        default:
          break
      }
      accessMenus(user, cdMenuChild)
    }

    return (
      <Row className='stock-adjustment-start'>
        <Col xs={3} xsOffset={3}>
          <Link
            to='stock-adjustment/done'
            onClick={() =>
              linkClick(cdMenuChild, 'stock.adjustment.made.title')
            }
          >
            <span>{translate('stock.adjustment.made.title')}</span>
            <span className='name color-text'>
              {translate('stock.adjustment.made.description')}
            </span>
          </Link>
        </Col>
        <Col xs={3}>
          <Link
            to='adjustment-values'
            onClick={() =>
              linkClick(cdMenuChild, 'stock.adjustment.value.title')
            }
          >
            <span>{translate('stock.adjustment.value.title')}</span>
            <span className='name color-text'>
              {translate('stock.adjustment.value.description')}
            </span>
          </Link>
        </Col>
      </Row>
    )
  }
}

StockAdjustment.propTypes = {
  translate: PropTypes.func.isRequired,
  accessMenus: PropTypes.func,
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  cdMenuChild: PropTypes.number,
}

export default StockAdjustment
